<div class="container bg-whitesmoke py-4">
  <app-breadcrumb></app-breadcrumb>
  
  <div class="ai-chat-container">
    <!-- Header -->
    <div class="header">
    <mat-icon class="robot-icon" color="primary">auto_awesome</mat-icon>
    <h2>AI Content Generator</h2>
    <p>Describe your product or service in detail to generate comprehensive content ideas</p>
  </div>

  <!-- Scrollable Content Area -->
  <div class="content-area">
    <!-- Intro state -->
    <div *ngIf="!hasResponse && !loading" class="intro">
      <div class="intro-card">
        <mat-icon class="large-icon" color="primary">description</mat-icon>
        <h3>Get Started</h3>
        <p>Tell us about your product or service, and we'll generate detailed content including:</p>
        <ul class="features-list">
          <li><mat-icon>check</mat-icon> Product/Service titles</li>
          <li><mat-icon>check</mat-icon> Detailed descriptions</li>
          <li><mat-icon>check</mat-icon> Key features</li>
          <li><mat-icon>check</mat-icon> Pricing suggestions</li>
        </ul>
      </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="loading" class="loading-state">
      <mat-progress-spinner diameter="48" mode="indeterminate" color="primary"></mat-progress-spinner>
      <p>Generating content ideas...</p>
    </div>

    <!-- Suggestions -->
    <div *ngIf="suggestions.length" class="suggestions-section">
      <div class="suggestions-header">
        <h3><mat-icon>lightbulb</mat-icon> Generated Content Ideas</h3>
        <p>Select the idea that best fits your needs</p>
      </div>
      
      <div
        *ngFor="let s of suggestions; let i = index"
        (click)="selectSuggestion(i)"
        class="suggestion-card"
        [class.selected]="selectedIndex === i"
      >
        <div class="suggestion-header">
          <div class="image-container">
            <img *ngIf="s.image" [src]="s.image" alt="{{ s.name }}" class="suggestion-image" />
            <div *ngIf="!s.image" class="no-image-placeholder">
              <mat-icon>inventory_2</mat-icon>
            </div>
          </div>
          <div class="suggestion-info">
            <h4>{{ s.name }}</h4>
            <p class="description">{{ s.description }}</p>
          </div>
          <button
            mat-stroked-button
            color="primary"
            class="select-btn"
            (click)="selectSuggestion(i); $event.stopPropagation()"
          >
            <mat-icon>{{ selectedIndex === i ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            {{ selectedIndex === i ? 'Selected' : 'Select' }}
          </button>
        </div>
        
        <div *ngIf="s.features && s.features.length" class="features-section">
          <h5><mat-icon>star</mat-icon> Key Features</h5>
          <div class="features-grid">
            <div *ngFor="let f of s.features" class="feature-item">
              <mat-icon>check_circle_outline</mat-icon>
              <span>{{ f }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Apply Selected Button (inside scrollable area) -->
    
  </div>
<div *ngIf="selectedIndex !== null" class="apply-section">
      <button mat-raised-button color="accent" class="apply-btn" (click)="applySelected()">
        <mat-icon>done</mat-icon>
        Apply Selected Content
      </button>
    </div>
  <!-- Fixed Input Container -->
  <div class="input-container">
    <form [formGroup]="chatForm" (ngSubmit)="sendMessage()" class="input-form">
      <mat-form-field class="input-field" appearance="outline">
        <mat-label>Describe your product or service in detail...</mat-label>
        <textarea 
          matInput 
          formControlName="userMessage" 
          [disabled]="loading"
          rows="2"
          placeholder="Example: I want to sell eco-friendly bamboo toothbrushes for health-conscious families..."
        ></textarea>
      </mat-form-field>

      <button 
        mat-fab 
        color="primary" 
        type="submit" 
        [disabled]="loading || !chatForm.get('userMessage')?.value?.trim()"
        class="send-btn"
      >
        <mat-icon *ngIf="!loading">send</mat-icon>
        <mat-progress-spinner
          *ngIf="loading"
          diameter="24"
          color="accent"
          mode="indeterminate"
        ></mat-progress-spinner>
      </button>
    </form>
  </div>
  </div>
</div>
